import React from 'react';

const Footer = () => {
    return (
        <div style={{padding: '20px', color: '#fff', textAlign: 'center', backgroundColor: '#2c3e50'}}>
            <span>©2021 SoftCopy. All rights reserved</span>
        </div>
    );
};

export default Footer;